import React from 'react';
export const useMonacoOptions = (fontSize, readOnly) => {
    const options = React.useMemo(() => ({
        fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : 12,
        readOnly: readOnly,
        formatOnPaste: true,
        formatOnType: true,
        contextmenu: false,
        minimap: { enabled: false },
        autoClosingBrackets: 'languageDefined',
        automaticLayout: true,
    }), [fontSize, readOnly]);
    return options;
};
